// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconExpandImage = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M23.6360404,22.078125 L17.3531017,15.796875 C18.7128422,14.1328125 19.5052424,12.0374994 19.5052424,9.75 C19.5052424,4.36546898 15.1400063,0 9.75262118,0 C4.36523602,0 0,4.36546898 0,9.75 C0,15.134531 4.36664259,19.5 9.75262189,19.5 C12.0402684,19.5 14.1389565,18.7073436 15.8011225,17.3887496 L22.0840612,23.6699996 C22.3044335,23.8921881 22.5951357,24 22.8811504,24 C23.1671651,24 23.4569301,23.8901253 23.6768331,23.6704216 C24.1142938,23.2312503 24.1142938,22.5187497 23.6360411,22.078125 L23.6360404,22.078125 Z M9.75262189,17.25 C5.6161976,17.25 2.2506056,13.8853126 2.2506056,9.75 C2.2506056,5.61468744 5.6161976,2.25 9.75262189,2.25 C13.8890462,2.25 17.2546382,5.61468744 17.2546382,9.75 C17.2546382,13.8853126 13.8881089,17.25 9.75262189,17.25 Z M13.50363,8.625 L10.8357258,8.625 L10.8357258,6 C10.8357258,5.37843704 10.3321527,4.875 9.75262189,4.875 C9.17309111,4.875 8.62731945,5.37656307 8.62731945,6 L8.62731945,8.625 L5.95941448,8.625 C5.37800779,8.625 4.87631059,9.12656236 4.87631059,9.75 C4.87631059,10.3734376 5.37941436,10.875 5.95941448,10.875 L8.62731945,10.875 L8.62731945,13.5 C8.62731945,14.121563 9.13042322,14.625 9.71042334,14.625 C10.3321527,14.625 10.7935272,14.121563 10.7935272,13.5 L10.7935272,10.875 L13.4192329,10.875 C14.1272346,10.875 14.6289325,10.3734376 14.6289325,9.75 C14.6289325,9.12656236 14.1272346,8.625 13.50363,8.625 Z"
            />
        </svg>
    );
};

export default React.memo(IconExpandImage);
